import type { FaireProductEntity } from "../../entity_types/product";

export const p_2q3ndfau3z: FaireProductEntity = {
  token: "p_2q3ndfau3z",
  type: "product",
  name: "Smoked Tomatillo Salsa",
  brandToken: "b_k8m6a3gz98",
  brandName: "212 SALSA",
  imageUrl:
    "https://cdn.faire.com/fastly/affbd3ba44510d39fc9194a0693c3b413d249f4d324a560ddb664132958d966f.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/4682631bbcbaad1600fcd37eecd8130e7e5f3ea938eeee57f176d524717e4ec8.jpeg",
    "https://cdn.faire.com/fastly/2d5f32daa6c48d4c948fd8252617b1ae0fed197ffbc981bef3e701a7c855d746.jpeg",
    "https://cdn.faire.com/fastly/71dad78d20b2f5f7b6b033174631ff549a05eedd53fcd020ab0b31975809bdc0.jpeg",
  ],
  priceDollars: 7.75,
  description:
    "212 SALSA makes fresh gourmet, refrigerated salsas.  Made in New York City with smoked tomatillos and three distinct chilis for a deep smokey flavor, a balanced blend of lime cilantro and garlic, and just the right amount of heat.  Shelf life is 133 days.",
  tags: [],
  msrpDollars: 14.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-06T19:20:09.894Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
